// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"10bbfff4","803":"db66c88c","883":"da6e55f2","966":"86235b2d"}[chunkId] + ".chunk.js";
};